export default __webpack_public_path__ + "images/5fa06a452f73c1374f32053c29066323-edm.webp";